import { render, staticRenderFns } from "./CancellationPolicy.html?vue&type=template&id=4c0309ea&scoped=true&external"
import script from "./CancellationPolicy.js?vue&type=script&lang=js&external"
export * from "./CancellationPolicy.js?vue&type=script&lang=js&external"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&id=4c0309ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0309ea",
  null
  
)

export default component.exports